<template>
  <div class="pagehead">
    <addscreen v-if="userInfo.token && !isRealLive()"></addscreen>
    <div class="fc-bg-fff fc-pad-lr">
      <p class="recharge_title">{{ $t('m.Diamonds_title', { msg: getAppName() }) }}</p>
      <div class="fc-pad-r fc-flex fc-flex-vcenter fc-pad-b-big">
        <img class="user_photo avater" :src="userInfo.img || require('../assets/img/h5_recharge_head.png')">
        <div class="fc-flex1 fc-mar-lr-sm">
          <p class="fc-text-big fc-elip-1 fc-text-bold" style="max-width: 3rem;" v-cloak>
            {{ userInfo.nickName || $t('m.login_no') }}</p>
          <p class="fc-text-usual fc-mar-t-min" v-cloak>
            {{ userInfo.userId ? 'ID:' + userInfo.userId : $t('m.login_after_recharge') }}</p>
        </div>
        <div class="fc-btn-line-main" @click="exitLogin" v-if="userInfo.userId">{{ $t('m.logout') }}</div>
        <div class="fc-btn-line-main" @click="enterLogin" v-else>{{ $t('m.login') }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import addscreen from '@/components/addscreen'
import { exitLogin } from "@/tools/common.js";
import {getAppName, isRealLive} from "../util";
export default{
  name:'haeder',
  components: {
    addscreen
  },
  props: {
      userInfo: {
        type: Object,
        default: function () {
            return {}
        }
      }
  },
  data(){
    return{
      deviceType:'',
    }
  },
  created() {

  },
  methods:{
    isRealLive,
    getAppName,
    //去登录页
    enterLogin() {
      this.$router.push({
        path: '/login'
      })
    },
    //退出登录
    exitLogin() {
      exitLogin()
    },
  }
}
</script>
<style scoped>

.add_main_screen {
  display: flex;
  align-items: center;
  min-height: .54rem;
  background-color: #D0E9FF;
  font-size: .24rem;
  padding: .15rem;
}

.add_main_screen .txt {
  flex: 1;
  padding: 0 .15rem;
}

.add_main_screen .btn {
  padding: .08rem .2rem;
  /* line-height: 1.3; */
  border-radius: 5rem;
  background-color: #008AFF;
  color: #fff;
  max-width: 2rem;
}

</style>



// WEBPACK FOOTER //
// src/components/pagehead.vue